import { useEffect, useState } from 'react';
import ShippingContainer from './ShippingContainer';
import { useLocation, useParams } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import { useAtom } from 'jotai';
import { targetShippingSeqAtom } from '@/commons/constants';

export default function FullScreenContainer() {
  const location = useLocation();
  const { t_shipping_id: pSeq } = useParams();
  const [cookieStatus, setCookieStatus] = useState(false);
  const [targetShipping, setTargetShipping] = useAtom(targetShippingSeqAtom);

  useEffect(() => {
    const queryParam = new URLSearchParams(location.search);
    const connectSid = queryParam.get('sid');
    const cookie = new Cookies();
    cookie.set('connect.sid', connectSid, { path: '/' });
    setCookieStatus(true);
  }, [location.search]);

  useEffect(() => {
    setTargetShipping(Number(pSeq));
  }, [pSeq]);

  return cookieStatus && targetShipping ? (
    <div style={{ width: '100%', height: '100%', padding: '1rem' }}>
      <ShippingContainer mode={'full'} />
    </div>
  ) : (
    <></>
  );
}
